// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_ae-3";
export var contentContainer = "_ae-0";
export var editorContainer = "_ae-1";
export var quillInputForm = "_ae-2";
export var zoneDivider = "_ae-4";